/* eslint-disable */
import { gsap, TweenMax } from 'gsap';

export {
    gsap,
    TweenMax
};
